@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

$linear-progress-weights: (
  light: 4px,
  medium: 8px,
  heavy: 12px
);

// ================================================================ //
// -- Mixins


@mixin create-progress-weights() {
  @each $key, $value in $linear-progress-weights {
    &.weight-#{$key} {
      height: $value;
      border-radius: $value * 2;

      .indicator-progress-bar {
        &.indeterminate {
          border-radius: $value * 2;
        }
      }
    }
  }
}

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-linear-progress {
    width: 100%;

    // ==== Label

    .label-container {
      width: 100%;
      font-size: inherit;
      line-height: inherit;
      padding-bottom: var(--label-padding-bottom);
    }

    .label-text {
      font-size: var(--label-font-size);
    }

    // ==== Container

    .indicator-container {
      display: flex;
      align-items: center;
      width: 100%;
    }

    // ==== Indicator Body

    .indicator-body {
      flex: 1 1 auto;
      width: 100%;
      position: relative;
      background-color: var(--indicator-background-color);
      overflow: hidden;
      contain: strict;

      @include create-progress-weights();
    }

    // ==== Indicator Progress Bar

    .indicator-progress-bar {
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: var(--progress-bar-color);

      &.indeterminate {
        animation: fluid-linear-progress-bounce 1.5s ease-in-out infinite alternate;
        will-change: left, width;
      }

      &.determinate {
        top: 0;
        bottom: 0;
        left: 0;
        will-change: transform;

        @include transition(
          $properties: 'transform',
          $duration: 150ms,
          $ease: false
        );

        transition-timing-function: linear;
      }
    }

    // ==== Indicator Value

    .indicator-value {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: inherit;
      line-height: 1;
      margin-left: 1em;
    }

    .indicator-value-text {
      font-size: var(--indicator-value-font-size);
      font-weight: 700;
      color: var(--indicator-value-color);
      white-space: nowrap;
    }
  }
}


// ================================================================ //
// -- Keyframe Animations

@keyframes fluid-linear-progress-bounce {
  from {
    left: 0;
  }

  to {
    left: 90%;
  }

  0% {
    width: 10%;
  }

  50% {
    width: 30%;
  }

  100% {
    width: 10%;
  }
}
